import React, {useState} from "react";
import img from "./assets/img.png";
import eye from "./assets/eye.png";
import love from "./assets/love.png";
import loveon from "./assets/love-on.png";
import send from "./assets/send.png";
import dot from "./assets/dot.png";
import walletpic from "./assets/wallet.png";
import black from "./assets/black.png";
import TokensVested from "../TokensVested/TokensVested";
import bag1 from "./assets/bag1.png";
import bag2 from "./assets/bag2.png";

import "./banner.css";
import Tabs from "../Tabs/Tabs";
import axios from 'axios';
import { useEffect, useContext, useRef } from "react";
import { useBalance, useAccount, useFeeData } from "wagmi";

import Popup from "reactjs-popup";
import BidModal from "../../../GlobalComponents/BidModal/BidModal";
import thum from "../../Marketplace/Banner/assets/thum.png";
import icon1 from "../../../GlobalComponents/NftCard/assets/Icon-Acquire.png";
import icon2 from "../../../GlobalComponents/NftCard/assets/Icon-Drip.png";
const Banner = ({buyClick}) => {
  const [open, setOpen] = useState(false);
  const [fireon, setFireon] = useState(0);
  const [firecount, setFireCount] = useState(0);
  const [initialized, setInitialized] = useState(0);
  const [isSendDropdownOpen, setIsSendDropdownOpen] = useState(false);
  const [isDotDropdownOpen, setIsDotDropdownOpen] = useState(false);
  const [sendDropdownPosition, setSendDropdownPosition] = useState({ top: 0, left: 0 });
  const [dotDropdownPosition, setDotDropdownPosition] = useState({ top: 0, left: 0 });
  const sendDropdownRef = useRef(null);
  const dotDropdownRef = useRef(null);
  var { address } = useAccount();
  const handleSendDropdownToggle = () => {
    setIsSendDropdownOpen(!isSendDropdownOpen);
  };

  const handleDotDropdownToggle = () => {
    setIsDotDropdownOpen(!isDotDropdownOpen);
  };

  const handleButtonClick = (event, dropdownType) => {
    const buttonRect = event.target.getBoundingClientRect();
    switch (dropdownType) {
      case 'send':
        setSendDropdownPosition({ top: buttonRect.bottom, left: buttonRect.left });
        handleSendDropdownToggle();
        break;
      case 'dot':
        setDotDropdownPosition({ top: buttonRect.bottom, left: buttonRect.left });
        handleDotDropdownToggle();
        break;
      default:
        break;
    }
  };
  const handleDropdownItemClick = (item) => {
    // Handle dropdown item click here
    console.log('Clicked:', item);
  };
  const checkWallet = async (data) => {
    try {
      const response = await axios.post('http://localhost:5000/api/check', { data:data });
      const exists = response.data.exists;
      return exists;
    } catch (error) {
      console.error('Error checking wallet:', error);
      throw error;
    }
  };
  const getCount = async (data) => {
    try {
      const response = await axios.post('http://localhost:5000/api/count', {
        data: data,
      });
      const count = response.data.count;
      return count;
    } catch (error) {
      console.error('Error getting count:', error);
      throw error;
    }
  };
  const insertData = async (data) => {
    try {
      const response = await axios.post('http://localhost:5000/api/like', {
        data: data,
      });
  
      const message = response.data.message;
      return message;
    } catch (error) {
      console.error('Error inserting data:', error);
      throw error;
    }
  };
  const deleteData = async (data) => {
    try {
      const response = await axios.post('http://localhost:5000/api/delete', {
          data: data,
      });

      const message = response.data.message;
      return message;
    } catch (error) {
      console.error('Error deleting data:', error);
      throw error;
    }
  };
  const onClickButton = async () => {
    if(!address)
      return;
    try {
      if (fireon) {
        const dataToDelete = {
          id: 0, // Replace with the actual ID
          wallet: address, // Replace with the actual wallet
          type: 'NFT', // Replace with the actual type
        };
        await deleteData(dataToDelete);
        console.log("Deleted successfully");
  
      } else {
        const dataToInsert = {
          id: 0, // Replace with the actual ID
          type: 'NFT', // Replace with the actual type
          wallet: address, // Replace with the actual wallet
        };
        await insertData(dataToInsert);
        console.log("Inserted successfully");
      }
  
      const dataToCount = {
        id: 0, // Replace with the actual ID
        type: "NFT" // Replace with the actual type
      };
      const count = await getCount(dataToCount);
      setFireCount(count);
      console.log("Count fetched successfully");
  
      setFireon(!fireon);
    } catch (error) {
      console.error('Error:', error);
      // Handle the error
    }
  };
  const Initialize = async () => {
    try {
      const dataToCount = {
        id: 0, // Replace with the actual ID
        type: "NFT" // Replace with the actual type
      };
      const count = await getCount(dataToCount);
      setFireCount(count);
      console.log("Count fetched successfully");
  
      const dataToCheck = {
        id: 0,
        type: 'NFT',
        wallet: address, // Replace with the actual wallet address
      };
      const exists = await checkWallet(dataToCheck);
      setFireon(exists ? 1 : 0);
      console.log("Wallet checked successfully");
    } catch (error) {
      console.error('Error:', error);
      // Handle the error
    }
  };
  Initialize();
  return (
    <div id="nft-auction-banner" className=" pt-[50px] md:pt-[139px]">
      <div className="max-w-[1410px] mx-auto flex flex-col xl:flex-row gap-[20px]   px-[20px]   2xl:px-0 2xl:gap-[100px]">
        <div className="grow">
          <img className="rounded-xl w-full" src={img} alt="" />
        </div>
        <div className="flex-none max-w-full xl:max-w-[620px]">
          {/* title start */}
          <div className="flex flex-col sm:flex-row justify-between items-center">
            <h2 className=" font-bold text-normal md:text-[36px] leading-[44px]">
              The <span className="text-main-green">R34P</span> Platinum
            </h2>
            <div className="text-res-xxs font-bold leading-[22px] flex justify-center flex-wrap gap-[12px]">
              <button onClick={onClickButton} className="flex h-[36px] w-[72px] justify-center items-center gap-[6px] rounded-[40px] bg-main-black">
                <img src={fireon?loveon:love} alt="" />
                <span className="font-bold  ">{firecount}</span>
              </button>
              <button onClick={(event) => handleButtonClick(event, 'send')} className="flex h-[36px] w-[36px] justify-center items-center  rounded-full bg-main-black">
                <img src={send} alt="" />
              </button>
              <button onClick={(event) => handleButtonClick(event, 'dot')} className="flex h-[36px] w-[36px] justify-center items-center  rounded-full bg-main-black">
                <img src={dot} alt="" />
              </button>
            </div>
          </div>

          {/* title ------------------ end */}

          <div className="mt-[20px] flex flex-col sm:flex-row gap-[30px]">
            {/* single -------green */}

            <div className="w-full pt-[12px] pb-[11px] px-[12px] h-[68px] bg-main-green rounded-[16px] flex gap-[12px]">
              <img src={walletpic} alt="" />
              <div>
                <h3 className="text-[13px] leading-[20px] text-main-black">
                  Owned By
                </h3>
                <p className="font-bold text-[15px] leading-[22px] text-main-black mt-[2px]">
                  0x736f...6245a9
                </p>
              </div>
            </div>

            {/* single -------green */}

            <div className="w-full pt-[12px] pb-[11px] px-[12px] h-[68px] bg-main-black rounded-[16px] flex gap-[12px]">
              <img src={black} alt="" />
              <div>
                <h3 className="text-[13px] leading-[20px] text-[#8A8AA0]">
                  Created By
                </h3>
                <p className="font-bold text-[15px] leading-[22px]  mt-[2px]">
                  The R34P DAO
                </p>
              </div>
            </div>
          </div>
          <div className="mt-[32px]">
            <TokensVested></TokensVested>
          </div>

          <div className="mt-[21px] flex flex-col md:flex-row gap-[30px]">
            <div className="bg-main-black flex justify-between items-center gap-2 w-full px-[24px] py-[12px] h-[50px] rounded-[8px]">
              <h2 className="text-[15px] text-[#EBEBEB]  leading-[26px] font-semibold text-res-xxs ">
                Current Bid
              </h2>
              <p>
                <span className="text-res-ls font-bold">4.89 ETH</span>
                <span className="text-[#EBEBEB] ml-[7px] text-[13px] leading-[20px]">
                  = $12.246
                </span>
              </p>
            </div>
            <div className="rounded-[8px] bg-main-black flex justify-between items-center gap-2 w-full px-[24px] py-[12px] h-[50px]">
              <h2 className="text-[15px] text-[#EBEBEB]  leading-[26px] font-semibold text-res-xxs ">
                BuyNow Price
              </h2>
              <p>
                <span className="text-res-ls font-bold">5.00 ETH</span>
                <span className="text-[#EBEBEB] ml-[7px] text-[13px] leading-[20px]">
                  = $12.246
                </span>
              </p>
            </div>
          </div>
          <div className="mt-[24px] flex  gap-[36px]">
            <button
              onClick={() => setOpen(true)}
              className="w-[295px] h-12 border rounded-[56px] border-solid border-white flex justify-center gap-[9px] items-center"
            >
              <img src={bag1} alt="" />
              <p className="font-bold text-[15px] leading-[22px]">
                Place a bid
              </p>
            </button>
            <button onClick={buyClick} className="w-[295px] h-12 rounded-[20px] bg-custom-gradient flex justify-center gap-[9px] items-center">
              <img src={bag2} alt="" />
              <p className="font-bold text-main-black  text-[15px] leading-[22px]">
                Buy Now
              </p>
            </button>
          </div>
          <div className="mt-[16px]">
            <Tabs></Tabs>
          </div>
        </div>
      {isSendDropdownOpen && (
        <div
          ref={sendDropdownRef}
          style={{ top: sendDropdownPosition.top, left: sendDropdownPosition.left }}
          className="absolute bg-[#18191D] rounded shadow"
        >
          <ul>
            <li
              className="cursor-pointer py-2 px-4 hover:bg-[#000000]"
              onClick={() => handleDropdownItemClick('Fire Option 1')}
            >
              Copy URL
            </li>
            <li
              className="cursor-pointer py-2 px-4 hover:bg-[#000000]"
              onClick={() => handleDropdownItemClick('Fire Option 2')}
            >
              Twitter post
            </li>
          </ul>
        </div>
      )}
      {isDotDropdownOpen && (
        <div
          ref={dotDropdownRef}
          style={{ top: dotDropdownPosition.top, left: dotDropdownPosition.left }}
          className="absolute bg-[#18191D] rounded shadow"
        >
          <ul>
            <li
              className="cursor-pointer py-2 px-4 hover:bg-[#000000]"
              onClick={() => handleDropdownItemClick('Fire Option 1')}
            >
              View Explorer
            </li>
          </ul>
        </div>
      )}
      </div>
      <Popup open={open} position="right center">
        <BidModal
          thum={thum}
          open={open}
          setOpen={setOpen}
          icon1={icon1}
          icon2={icon2}
        ></BidModal>
      </Popup>
    </div>
  );
};

export default Banner;
